import { l } from 'ui/lib/lodashImports'

export const stringExists = (string: string): boolean =>
	!l.isNil(string) && string !== ''
